module.exports = __webpack_public_path__ + "static/media/Logo.e320b358.png";